import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import RankedTable from "../layout/RankedTable";
import AppButton from "../layout/AppButton";
import AddVisualsToReportDialog from "./AddVisualsToReportDialog";
import { formatDateTime } from "../../utils/dateFormat";

const PAGE_SIZE = 10;

const ReportManagementTable = ({
  searchText,
  setSearchText,
  filteredReports,
  onEditReport,
  onDeleteReport,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(filteredReports.length / PAGE_SIZE);
  const currentData = filteredReports.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(0);
  };

  return (
    <div className="pb-2">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3 px-1">
        <div className="flex items-center gap-3">
          <input
            type="text"
            className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            style={{ minWidth: "300px" }}
            placeholder="Search by report, report id, or group id"
            value={searchText}
            onChange={handleSearch}
          />
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={"‹"}
            nextLabel={"›"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            forcePage={currentPage}
            containerClassName={"pagination"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        )}
      </div>

      <RankedTable
        columns={[
          { label: "Report Name" },
          { label: "Report ID / Group ID / Dataset ID" },
          { label: "Created At" },
          { label: "RLS", align: "left" },
          { label: "Actions", align: "left", width: "22%" },
        ]}
        rows={currentData}
        emptyText="No matching reports found."
        renderRow={(report) => (<>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="font-bold text-gray-800 text-xs">{report.reportName}</span>
              {report.createdBy && <span className="text-[11px] text-gray-400">{report.createdBy}</span>}
            </div>
          </td>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-gray-500 text-xs font-mono">R:{report.reportId}</span>
              <span className="text-gray-400 text-[11px]">G:{report.groupId}</span>
              {report.datasetId && <span className="text-gray-400 text-[11px] font-mono" title={report.datasetId}>D:{report.datasetId}</span>}
            </div>
          </td>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-gray-500 text-xs">{formatDateTime(report.createdAt).date}</span>
              <span className="text-gray-400 text-[11px]">{formatDateTime(report.createdAt).time}</span>
            </div>
          </td>
          <td className="px-5 py-3 text-left">
            <span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full ${
              report.rlsEnabled ? "bg-emerald-100 text-emerald-700" : "bg-gray-100 text-gray-500"
            }`}>
              {report.rlsEnabled ? "Enabled" : "Disabled"}
            </span>
          </td>
          <td className="px-5 py-3 text-left">
            <div className="flex items-center justify-start gap-2">
              <AddVisualsToReportDialog report={report} />
              <AppButton
                variant="fill"
                onClick={() => onEditReport(report)}
                style={{ padding: "4px 12px", fontSize: "11px" }}
              >
                Edit
              </AppButton>
              <AppButton
                variant="outline"
                onClick={() => onDeleteReport(report.reportId)}
                style={{ padding: "4px 12px", fontSize: "11px" }}
              >
                Delete
              </AppButton>
            </div>
          </td>
        </>)}
      />
    </div>
  );
};

export default ReportManagementTable;
